<button
  class="back-button"
  [class.reporting-styling]="isReportingPage"
  [class.hide]="!showBack"
  (click)="goBack()"
  [ngStyle]="{ color: customColour.length ? customColour : 'auto' }"
></button>
